//messages.js
export default {
	general: "General",
	overview: "Visión de conjunto",
	customizer: "Personalizador",
	applications: "Aplicaciones",
	features: "Caracteristicas",
	components: "Componentes",
	salesAndVisitStats: "Estadísticas de ventas y visitas",
	orderAndProjectStats: "Estadísticas de pedidos y proyectos",
	fitnessStats: "Estadísticas de estado físico",
	supportAndUsefulWidgets: "Soporte y widgets útiles",
	dashboard: "Tablero",
	dashboardOverview: "Vista general del tablero",
	dashboardv1: "Tablero V1",
	dashboardv2: "Tablero V2",
	widgets: "Widgets",
	horizontalMenu: "Menú horizontal",
	pages: "Páginas",
	gallery: "Galería",
	pricing: "Precios",
	pricing1: "Precios 1",
	pricing2: "Precios 2",
	blank: "Blanco",
	session: "Sesión",
	signUp1: "Regístrese 1",
	signUp2: "Registrarse 2",
	login1: "Login 1",
	login2: "Login 2",
	lockScreen: "Bloquear pantalla",
	uiElements: "Elementos de UI",
	buttons: "Botones",
	cards: "Tarjetas",
	checkbox: "Caja",
	carousel: "Carrusel",
	chips: "Papas fritas",
	datepicker: "Selector de fechas",
	dialog: "Diálogo",
	grid: "Cuadrícula",
	input: "Entrada",
	list: "Lista",
	menu: "Menú",
	progress: "Progreso",
	radio: "Radio",
	select: "Seleccionar",
	slider: "Control deslizante",
	snackbar: "Snackbar",
	tabs: "Pestañas",
	toolbar: "Barra de herramientas",
	tooltip: "Información sobre herramientas",
	timepicker: "Timepicker",
	forms: "Formularios",
	formValidation: "Validación de formulario",
	stepper: "Paso a paso",
	charts: "Gráficos",
	vueChartjs: "Vista de Chartjs",
	vueEcharts: "Vue Echarts",
	icons: "Iconos",
	themify: "Themify",
	material: "Material",
	tables: "Mesas",
	standard: "Estándar",
	slots: "Slots",
	selectable: "Seleccionable",
	searchRow: "Fila de búsqueda",
	maps: "Mapas",
	googleMaps: "mapas de Google",
	leafletMaps: "Mapas de folletos",
	jvectorMap: "Mapa Jvector",
	inbox: "Bandeja de entrada",
	users: "Usuarios",
	userProfile: "Perfil del usuario",
	usersList: "Lista de usuarios",
	calendar: "Calendario",
	editor: "Editor",
	quillEditor: "Quill Editor",
	wYSIWYG: "WYSIWYG",
	vue2Dragula: "Vue2 Dragula",
	dragAndDrop: "Arrastrar y soltar",
	vueDraggable: "Vue Draggable",
	draggableResizeable: "Dragizable Resizeable",
	chat: "Charla",
	todo: "Todo",
	modules: "Módulos",
	user: "Usuario",
	miscellaneous: "Diverso",
	promo: "Promoción",
	connections: "Conexiones",
	follow: "Seguir",
	unfollow: "Dejar de seguir",
	basicValidation: "Validación Básica",
	validationWithSubmitAndclear: "Validación con submit & clear",
	submit: "Enviar",
	clear: "Claro",
	step1: "Paso 1",
	step2: "Paso 2",
	step3: "Paso 3",
	continue: "Continuar",
	cancel: "Cancelar",
	totalEarnings: "Ganancias Totales",
	onlineRevenue: "Ingresos en línea",
	offlineRevenue: "Ingresos sin conexión",
	marketingExpenses: "Gastos de mercadotecnia",
	markAsPaid: "Marcar como pagado",
	markAsNotPaid: "Marcar como no pagado",
	markAsShipped: "Marcar como enviado",
	newCustomers: "nuevos clientes",
	visitAndSalesStatistics: "Estadísticas de visita y ventas",
	salesStatistics: "Estadísticas de ventas",
	collapse: "Colapso",
	reload: "Recargar",
	close: "Cerrar",
	bandwidthUsage: "Uso de Ancho de Banda",
	shoppingCart: "Carrito de compras",
	totalDownloads: "Descargas totales",
	productSales: "Venta de productos",
	projectStatus: "Estado del proyecto",
	averageSteps: "Pasos promedio",
	todaysDistance: "Distancia de hoy",
	todaysStep: "El paso de hoy",
	todaysGoal: "Meta de hoy",
	calories: "Calorías",
	weeklySummary: "Resumen semanal",
	supportTickets: "Boletos de soporte",
	todoList: "Lista de quehaceres",
	newsletterCampaign: "Campaña del boletín",
	currentVisitors: "Visitantes actuales",
	newMembers: "Nuevos miembros",
	addNewBlog: "Agregar nuevo blog",
	add: "Añadir",
	logOut: "Salir",
	totalAppMemory: "Total de memoria de la aplicación",
	totalMemoryUsed: "Memoria total utilizada",
	unreadMail: "12 correo no leído",
	feedback: "Realimentación",
	flatButton: "Botón plano",
	raisedButton: "Botón elevado",
	gradientButton: "Botón de degradado",
	buttonDropdownVariants: "Variantes desplegables de botones",
	buttonToggle: "Botón Alternar",
	icon: "Icono",
	normal: "Normal",
	enabled: "Habilitado",
	disabled: "Deshabilitado",
	floating: "Flotante",
	loaders: "Cargadores",
	sizing: "Dimensionamiento",
	outline: "contorno",
	round: "Redondo",
	block: "Bloquear",
	search: "Buscar",
	checkboxesBoolean: "Casillas de verificación Booleanas",
	checkboxesArray: "Casillas de verificación Matriz",
	checkboxesStates: "Casillas de verificación: estados",
	checkboxesColors: "Casillas de verificación - Colores",
	switches: "Interruptores",
	default: "Defecto",
	customTransition: "Transición personalizada",
	customDelimiter: "Delimitador personalizado",
	hideControls: "Ocultar controles",
	hideDelimiters: "Ocultar delimitadores",
	colored: "De colores",
	label: "Etiqueta",
	closeable: "Cerrable",
	datePickerHorizontal: "Selector de fecha horizontal",
	datePickerVertical: "Selector de fecha vertical",
	datePickersInDialogAndMenu: "Selector de Fecha- En Diálogo y Menú",
	datePickersWithModal: "Selector de fecha con modal",
	datePickersFormattingDate: "Selector de fecha: fecha de formateo",
	simpleDialogs: "Cuadros de diálogo simples",
	withoutActivator: "Sin activador",
	scrollable: "Desplazable",
	listOfAllMaterialIcons: "Lista de todos los iconos de material",
	arrowsAndDirectionsIcons: "FLECHAS Y ICONOS DE DIRECCIÓN",
	webAppIcons: "ICONOS DE APLICACIONES WEB",
	CONTROLICONS: "ICONOS DE CONTROL",
	TEXTEDITOR: "EDITOR DE TEXTO",
	LAYOUTICONS: "ICONOS DE DISEÑO",
	BRANDICONS: "ICONOS DE MARCA",
	newClients: "Nuevos clientes",
	recurringClients: "Clientes recurrentes",
	bounceRate: "Porcentaje de rebote",
	pageViews: "Vistas de página",
	usefulWidgets: "Widgets útiles",
	sale: "Venta",
	sales: "Ventas",
	saleDetails: "Detalles de la venta",
	invoices: "Facturas",
	referrals: "Referencias",
	serverLoad: "Carga del servidor",
	recentSale: "Venta reciente",
	supportRequest: "Solicitud de soporte",
	productSale: "Venta de productos",
	viewAll: "VER TODO",
	barChart: "Gráfico de barras",
	polarAreaChart: "Gráfico de área polar",
	lineChart: "Gráfico de linea",
	radarChart: "Gráfico de radar",
	doughnutChart: "Carta de Donut",
	bubbleChart: "Gráfico de burbujas",
	gradientLineChart: "Gradient Line Chart",
	pieChart: "Gráfico circular",
	funnelChart: "Gráfico de embudo",
	loginNow: "Inicia sesión ahora",
	createAccount: "Crear una cuenta",
	termsOfService: "Términos de servicio",
	bySigningUpYouAgreeTo: "Al registrarte aceptas",
	loginToAdmin: "Ingresar a la administración",
	loginToStore: "Ingresar a tu tienda",
	enterUsernameAndPasswordToAccessControlPanelOf:
		"Ingrese nombre de usuario y contraseña para acceder al panel de control de",
	havingAnAccount: "¿Tienes una cuenta?",
	quickLinks: "enlaces rápidos",
	type: "Tipo",
	plan: "Plan",
	plans: "Planes",
	chooseThePlanThatWorksForYou: "Elija el plan que funcione para usted.",
	monthly: "Mensual",
	yearlyGet2MonthExtra: "Anualmente (obtenga 2 meses adicionales)",
	extras: "Extras",
	addExtra: "Añadir Extra",
	editExtra: "Editar Extra",
	basic: "BASIC",
	pro: "Pro",
	advanced: "Avanzado",
	basicFree: "Básico (Gratis)",
	startToBasic: "Comience a básico",
	upgradeToPro: "Actualizar a Pro.",
	upgradeToAdvance: "Actualizar a Advance",
	comparePlans: "Comparar planes",
	frequentlyAskedQuestions: "Preguntas frecuentes",
	defaultInput: "Entrada predeterminada",
	activator: "Activador",
	hover: "Flotar",
	menus: "Menús",
	indeterminate: "Indeterminado",
	sizeAndWidth: "Tamaño y ancho",
	rotate: "Girar",
	determinate: "Determinado",
	buffer: "Buffer",
	radiosDefault: "Radios predeterminados",
	radiosDirectionRow: "Línea de dirección de radios",
	radiosDirectionColumn: "Columna de dirección de radios",
	radiosColors: "Radios - Colores",
	switchesColors: "Interruptores - Colores",
	continuous: "Continuo",
	discrete: "Discreto",
	customColors: "Colores personalizados",
	editableNumericValue: "Valor numérico editable",
	contextualSnackbar: "Barra de snack contextual",
	showSnackbar: "Mostrar Snackbar",
	centeredTabs: "Fichas centradas",
	toolbarTabs: "Pestañas de la barra de herramientas",
	theDefaultColorToolbar: "La barra de herramientas de color predeterminada",
	appBar: "Barra de aplicaciones",
	appBarWithExtension: "Barra de aplicaciones con extensión",
	visibility: "Visibilidad",
	top: "Parte superior",
	right: "Derecha",
	bottom: "Fondo",
	left: "Izquierda",
	toggle: "Palanca",
	timePicker: "Selector de tiempo",
	timePickerInDialogAndMenu:
		"Selector de tiempo: en el cuadro de diálogo y el menú",
	itemsAndHeaders: "Artículos y encabezados",
	selectableRows: "Filas seleccionables",
	headerCell: "Header CellHeader Cell",
	expand: "Expandir",
	recentChat: "Chat reciente",
	previousChats: "Chats anteriores",
	addNewItems: "Agregar nuevos artículos",
	addToDo: "Añadir para hacer",
	yes: "Sí",
	no: "No",
	ok: "De acuerdo",
	activeUsers: "Usuarios activos",
	addNew: "Agregar nuevo",
	addNewStore: "Agregar Nueva Tienda",
	readMore: "Lee mas",
	assignNow: "Asignar ahora",
	totalRequest: "Solicitud total",
	new: "Nuevo",
	pending: "Pendiente",
	update: "Actualizar",
	updated10MinAgo: "Actualizado hace 10 min",
	addNewCustomer: "Añadir nuevo cliente",
	name: "Nombre",
	email: "Email",
	editMember: "Editar miembro",
	scheduleDate: "Fecha de programacion",
	title: "Título",
	newEmails: "Nuevos correos electrónicos",
	newEmail: "Nuevo Email",
	employeePayroll: "Nómina de empleados",
	forMostOfTheUsers: "Para la mayoría de los usuarios",
	choosePlan: "Elija Plan",
	mega: "Mega",
	master: "Dominar",
	forDeveloper: "Para desarrollador",
	forLargeEnterprises: "Para grandes empresas",
	composeEmail: "Escribir correo",
	mailboxes: "Buzones",
	folders: "Carpetas",
	inbox5: "Bandeja de entrada (5)",
	draft: "Borrador",
	starred: "Sembrado de estrellas",
	sentMessages: "Mensajes enviados",
	spam: "Correo no deseado",
	delete: "Borrar",
	share: "Compartir",
	dndNotice: "Arrastre y suelte los elementos para ordenar",
	reorder: "Ordenar",
	index: "Posición",
	work: "Trabajo",
	personal: "Personal",
	manageFolders: "Administrar carpetas",
	contacts: "Contactos",
	settings: "Configuraciones",
	themeOptions: "Opciones de tema",
	darkMode: "Modo oscuro",
	collapseSidebar: "Contraer la barra lateral",
	boxLayout: "Diseño de caja",
	rtlLayout: "Diseño Rtl",
	backgroundImage: "Imagen de fondo",
	sidebarFilters: "Filtros de la barra lateral",
	danger: "Peligro",
	primary: "Primario",
	warning: "Advertencia",
	success: "Éxito",
	info: "Información",
	dailySales: "Ventas diarias",
	trafficChannel: "Canal de tráfico",
	campaignPerformance: "Rendimiento de la campaña",
	goToCampaign: "Ir a Campaña",
	fullScreen: "Pantalla completa",
	ecommerce: "E-Commerce",
	shop: "tienda",
	cart: "Carro",
	total: "Total",
	totalPrice: "Precio total",
	totalPurchases: "Compras Realizadas",
	totalToPay: "Total a pagar",
	totalSold: "Total vendido",
	totalSoldInBs: "Total vendido en VES",
	totalVerifiedSales: "Ventas totales verificadas",
	viewCart: "Ver carro",
	checkout: "Revisa",
	apply: "Aplicar",
	noItemsFound: "No se encontraron artículos",
	billingDetails: "Detalles de facturación",
	placeOrder: "Realizar pedido",
	addNewCard: "Agregar nueva tarjeta",
	devicesShare: "Dispositivos compartidos",
	customers: "Clientes",
	myCustomers: "Mis Clientes",
	totalCustomers: "Clientes totales",
	customerOverview: "Descripción del cliente",
	reviews: "Comentarios",
	weeklySales: "Ventas semanales",
	recentOrders: "órdenes recientes",
	categorySales: "Categoría Ventas",
	webAnalytics: "analista de la red",
	topSelling: "Más vendidos",
	social: "Social",
	newPost: "Nueva publicación",
	publish: "Publicar",
	magazine: "Revista",
	editUser: "Editar usuario",
	addNewUser: "Añadir nuevo usuario",
	dark: "Oscuro",
	light: "Ligero",
	recentUsers: "Usuarios recientes",
	activityAroundWorld: "Actividad alrededor del mundo",
	adsIncome: "Ingresos de anuncios",
	recentComments: "Comentarios Recientes",
	recentNotifications: "Notificaciones recientes",
	messages: "Mensajes",
	message: "Mensaje",
	edit: "Editar",
	topAuthors: "Autores principales",
	marketingCampaign: "CAMPAÑA de Marketing",
	articles: "Artículos",
	websiteTraffic: "Tráfico del sitio web",
	agency: "Agencia",
	recent: "Reciente",
	trending: "Tendencias",
	totalPageViews: "Páginas vistas en total",
	impressions: "Impresiones",
	deviceSeparations: "Separaciones de dispositivos",
	browserStatics: "Estadísticas del navegador",
	totalDownloading: "Descarga total",
	notifications: "Notificaciones",
	totalBookmarked: "Total marcado como favorito",
	itemsDownloads: "Artículos Descargas",
	itemsUploaded: "Artículos cargados",
	totalAnalytics: "Total Analytics",
	hotKeywords: "Palabras clave calientes",
	MaleUsers: "Usuarios Masculinos",
	serverStatus: "El estado del servidor",
	purchaseVuely: "Compra Vuely",
	letsGetInTouch: "Mantengámonos en contacto",
	maleUsers: "Usuarios Masculinos",
	femaleUsers: "Usuarios femeninos",
	androidUsers: "Usuarios de Android",
	iOSUsers: "Usuarios de iOS",
	advance: "Avanzar",
	routerAnimation: "Animación de enrutador",
	salesAndEarning: "Ventas y Ganancias",
	netProfit: "Beneficio neto",
	totalExpences: "Gastos totales",
	photos: "Fotos",
	adCampaignPerfomance: "Campaña publicitaria Perfomance",
	profitShare: "División de ganancias",
	topSellingTheme: "Tema más vendido",
	newRequest: "Nueva solicitud",
	followers: "Seguidores",
	mailbox: "Buzón",
	sent: "Expedido",
	birthdays: "Cumpleaños",
	events: "Eventos",
	event: "Evento",
	newsletter: "Hoja informativa",
	lastMonth: "El mes pasado",
	lastUpdate: "Ultima actualización",
	allTime: "Todo el tiempo",
	composeNewEmail: "Componer nuevo correo electrónico",
	activity: "Actividad",
	message: "Mensaje",
	selectTheme: "Seleccione el tema",
	continueShopping: "Seguir comprando",
	proceedToCheckout: "Pasar por la caja",
	headerFilters: "Filtros de encabezado",
	blog: "Blog",
	signUp: "Crea tu cuenta GRATIS",
	signUpSub: "para siempre gratis. No necesitas ingresar método de pago.",
	signUpRedirect:
		"Estas por ser redirigido. Si esto no funciona haz click aquí.",
	login: "Inicia sesión",
	news: "Noticias",
	topHeadlines: "Titulares principales",
	visitors: "Visitantes",
	subscribers: "Suscriptores",
	twitterFeeds: "Twitter Feeds",
	extensions: "Extensiones",
	imageCropper: "Imagen Cropper",
	videoPlayer: "Reproductor de video",
	dropzone: "Zona de descenso",
	baseConfig: "Configuración de base",
	audioTrackAndPlaysInline: "Pista de audio y reproducciones en línea",
	hlsLive: "HLS Live",
	forgotPassword: "Se te olvidó tu contraseña",
	joinCommunity: "Visita nuestra comunidad en telegram",
	resetPassword: "Restablecer la contraseña",
	backToSignIn: "Volver a iniciar sesión",
	enterYourEmailToSendYouAResetLink:
		"Ingrese su correo electrónico para enviarle un enlace de reinicio",
	pleaseEnterYourNewPassword: "Por favor ingrese su nueva contraseña",
	saas: "SAAS",
	overallTrafficStatus: "Estado general del tráfico",
	projectManagement: "Gestión de proyectos",
	projectTaskManagement: "Project Task Management",
	totalSales: "Ventas totales",
	totalSpent: "Total Gastado",
	simple: "Sencillo",
	transitions: "Transiciones",
	tax: "Impuesto",
	expenses: "Gastos",
	images: "Imágenes",
	ratings: "Calificaciones",
	containAndCover: "Contener y cubrir",
	height: "Altura",
	fixedRatio: "Proporción fija",
	gradients: "Gradientes",
	sizeVariants: "Variantes de tamaño",
	newIcons: "Nuevos iconos",
	webApplication: "Aplicación web",
	person: "Persona",
	file: "Archivo",
	comment: "Comentario",
	form: "Formar",
	hardware: "Hardware",
	directional: "Direccional",
	mapAliases: "Mapa (alias)",
	dateAndTime: "Fecha y hora",
	groups: "Los grupos",
	buttonGroups: "Grupos de botones",
	itemGroups: "Grupos de artículos",
	windows: "Windows",
	onBoarding: "En el embarque",
	accountCreation: "Creación de cuenta",
	treeview: "Vista de árbol",
	customSelectableIcons: "Iconos seleccionables personalizados",
	timelines: "Líneas de tiempo",
	usage: "Uso",
	scopedSlots: "Ranuras de ámbito",
	asyncItems: "Async Items",
	smallDots: "Pequeños puntos",
	iconDots: "Puntos de iconos",
	coloredDots: "Puntos de colores",
	oppositeSlot: "Ranura opuesta",
	denseAlert: "Alerta densa",
	fixedTabs: "Pestañas fijas",
	rightAlignedTabs: "Pestañas alineadas a la derecha",
	content: "Contenido",
	withSearch: "Con busqueda",
	iconsAndText: "Iconos y texto",
	grow: "Crecer",
	pagination: "Paginación",
	customIcons: "Iconos personalizados",
	courses: "Los cursos",
	coursesList: "Lista de cursos",
	courseDetail: "Detalles de los cursos",
	signIn: "Registrarse",
	pay: "Pagar",
	payment: "Pago",
	paymentToDealer: "Pago al repartidor",
	paymentStatus: "Estado del pago",
	paymentRejected: "Pago rechazado",
	LearnWithYourConvenience: "Aprende con tu conveniencia",
	management: "administración",
	design: "Diseño",
	development: "Desarrollo",
	top: "Parte superior",
	new: "Nuevo",
	trending: "Tendencias",
	bestseller: "Mejor vendido",
	addToCart: "Añadir a la cesta",
	popularInstructors: "Instructores populares",
	moreCoursesFromJamesColt: "Más cursos de James Colt",
	whatYoWillLearn: "Lo que vas a aprender",
	description: "Descripción",
	aboutInstructor: "Sobre el instructor",
	userSignIn: "Iniciar sesión de usuario",
	guestCheckout: "Checkout de invitado",
	continueAsGuest: "Continua como invitado",
	paymentOptions: "Opciones de pago",
	offerCode: "Ofrece código",
	enterCardDetails: "Ingrese los detalles de la tarjeta",
	submit: "Enviar",
	clear: "Claro",
	firstSteps: "Primeros pasos",
	makePayment: "Hacer el pago",
	usage: "Uso",
	withContent: "Con contenido",
	customHeight: "Altura personalizada",
	lastname: "Apellido",
	welcomeMessages: "Mensajes de bienvenida",
	links: "Links",
	webBot: "Bot Web",
	webStore: "Tienda online",
	telegramStore: "Tienda Telegram",
	store: "Tienda",
	stores: "Tiendas",
	storeAlias: "Alias de la Tienda",
	storeBotName: "Nombre del Bot de la Tienda",
	storeProfile: "Perfil de Tienda",
	storeSchedule: "Horario de la Tienda",
	storeName: "Nombre de la Tienda",
	storeDescription: "Descripción de la Tienda",
	storeCategory: "Categoria de la Tienda",
	storeInformation: "Información de la tienda",
	saveRate: "Guardar tasa ",
	faq: "Preguntas Frecuentes",
	catalogue: "Catalogos",
	productList: "Lista de Productos",
	product: "Producto",
	images: "Imagenes",
	addImages: "Agregar Imagenes",
	addImage: "Agregar imagen",
	telegramUsers: "Usuarios de Telegram",
	shoppingList: "Compras",
	shoppingDetails: "Detalles de la compra",
	shippingDetails: "Detalles del envio",
	shippingType: "Tipo de envio",
	bankList: "Lista de bancos",
	editBank: "Editar Banco",
	addBank: "Crear Banco",
	subscription: "Subscripcion",
	addTime: "Agregar Tiempo",
	statuses: "Estados",
	status: "Estado",
	createDate: "Fecha de creación",
	expireDate: "Fecha de finalización",
	save: "Guardar",
	errorStoreName: "Por favor, especifique el nombre de la tienda",
	errorStoreDescription: "Por favor, especifique la descripción de la tienda",
	errorName: "Por favor, especifique el nombre",
	errorEmail: "Por favor, especifique el email",
	invalidEmail: "Email invalido",
	errorStatus: "Por favor, especifique el estado",
	actions: "Acciones",
	password: "Contraseña",
	confirmPassword: "Confirmar contraseña",
	confirmedBy: "Confirmado por",
	numberMonths: "Numero de Meses",
	telegramUser: "Usuario de Telegram",
	mainTelegramUser: "Usuario Principal Telegram",
	alternativeTelegramUser: "Usuario Alternativo Telegram",
	telegramBotToken: "Token del Bot de Telegram",
	latitude: "Latitud",
	longitude: "Longitud",
	howCreateBot: "Como crear un bot de telegram",
	location: "Ubicación",
	addLocation: "Agregar Localización",
	selectLocation: "Selecciona tu localización",
	accountType: "Tipo de cuenta",
	moneyType: "Tipo de Moneda",
	accountNumber: "Número de Cuenta",
	accountNumberIdentifier: "Número de Cuenta/Identificador",
	identification: "Identificación",
	ownerName: "Titular",
	editOwnerName: "Editar Titular",
	ownerDocument: "Documento",
	deleteConfirmation: "Confirmar eliminar",
	deleteMessage: "¿Esta seguro de eliminar esto?",
	bankName: "Nombre del Banco",
	documentType: "Tipo de documento",
	editCatalogue: "Editar catalogo",
	addCatalogue: "Añadir catalogo",
	errorDescription: "Por favor, especifique la descripción",
	sendMessageAllClients: "Enviar mensaje a todos",
	sendMessage: "Enviar mensaje",
	sendMessageTo: "Enviar mensaje a",
	send: "Enviar",
	purchase: "Compra",
	purchases: "Compras",
	purchaseStatus: "Estado de la compra",
	purchaseDate: "Fecha de la compra",
	startDate: "Fecha de inicio",
	endDate: "Fecha de cierre",
	telegramId: "ID de telegram",
	client: "Cliente",
	verified: "Verificada",
	verifieds: "Verificados",
	verify: "Por verificar",
	rejected: "Rechazada",
	receiptImage: "Imagen del Comprobante",
	delivery: "Delivery",
	deliveries: "Deliveries",
	delivered: "Entregada",
	dealer: "Repartidor",
	dealers: "Repartidores",
	dealerId: "Cédula del Repartidor",
	dealerName: "Nombre del Repartidor",
	dealerLastname: "Apellido del Repartidor",
	addDealer: "Agregar Repartidor",
	editDealer: "Editar Repartidor",
	dealerDetails: "Detalles del Repartidor",
	deliveryEnabled: "Delivery Habilitado",
	deliveryDisabled: "Delivery Deshabilitado",
	deliveryAddress: "Dirección de entrega",
	deliveryPrice: "Precio del delivery",
	deliveryId: "Id Delivery",
	deliveryProfile: "Perfil Delivery",
	deliveryType: "Tipo de entrega",
	deliveryDate: "Fecha de entrega",
	products: "Productos",
	price: "Precio",
	quantity: "Cantidad",
	confirmPayment: "Confirmar pago",
	confirmShipping: "Confirm envio",
	details: "Detalles",
	editProduct: "Editar producto",
	addProduct: "Añadir producto",
	productLink: "Enlace del archivo",
	productLinkExplanation:
		"Este es en enlace que se compartirá con tus clientes",
	errorPrice: "Por favor, especifique el precio",
	errorCatalogue: "Por favor, especifique el catalogo",
	errorQuantity: "Por favor, especifique una cantidad válida",
	sendPromo: "Enviar Promoción",
	addFaq: "Añadir Pregunta Frecuente",
	editFaq: "Editar Pregunta Frecuente",
	question: "Pregunta",
	answer: "Respuesta",
	rating: "Rating",
	productsMoreSelled: "Productos mas vendidos",
	totalInSales: "Total en Ventas",
	totalInVes: "Total en VES",
	topClients: "Mejores clientes",
	yadioRate: "Tasa Yadio",
	exchangeRate: "Tasa de cambio",
	manualExchangeRate: "Tasa de cambio manual",
	deny: "Denegar",
	denied: "Rechazada",
	totalSalesVES: "Total en Bolívares",
	sellsPerWeek: "Ventas De La semana",
	telephone: "Teléfono",
	address: "Dirección",
	city: "Ciudad",
	country: "País",
	state: "Estado",
	monday: "Lunes",
	tuesday: "Martes",
	wednesday: "Miercoles",
	thursday: "Jueves",
	friday: "Viernes",
	saturday: "Sabado",
	sunday: "Domingo",
	opening: "Apertura",
	closing: "Cierre",
	open: "Abierto",
	closed: "Cerrado",
	profile: "Perfil",
	schedule: "Horario",
	addressReference: "Dirección De Referencia",
	newImage: "Nueva Imagen",
	storeUpdatedSuccessfully: "La tienda ha sido actualizada exitosamente",
	sendBroadcast: "Enviar Difusión",
	topStores: "Top Tiendas",
	percentageAboveDollar: "Porcentage por encima del dolar",
	rate: "Tarifa",
	rates: "Tarifas",
	ratePreview: "Vista previa de la tasa",
	extendMembership: "Extender Membresia",
	bank: "Banco",
	banks: "Bancos",
	confirmDelivery: "Confirmar Entrega",
	cashiers: "Cajeros",
	addCashier: "Añadir Cajero",
	editCashier: "Editar Cajero",
	shippings: "Envíos",
	addRate: "Añadir tarifa",
	editRate: "Editar tarifa",
	shippingRates: "Tarifas de envio",
	paid: "Pagado",
	notPaid: "Por pagar",
	privateKey: "Llave privada",
	id: "Id",
	totalPaid: "Total Pagado",
	shareLink: "Enlace de invitación",
	registerAs: "Registrarse como",
	linkedStores: "Tiendas asociadas",
	deliveryCompany: "Compañia de Delivery",
	deliveryCompanies: "Compañias de Delivery",
	orderStatus: "Estatus de la orden",
	paymentMethod: "Método de Pago",
	paymentMethods: "Métodos de Pago",
	code: "Código",
	primaryUserAdministrator: "Usuario Administrador Primario",
	secondaryUserAdministrator: "Usuario Administrador Secundario",
	companyName: "Nombre de la compañia",
	purchasesToVerify: "Compras por verificar",
	deliveryCost: "Costo del envio",
	chargedBy: "Cobrado por",
	allowCharge: "Puede cobrar",
	denyCharge: "No puede cobrar",
	shipped: "Enviada",
	ownDelivery: "Delivery Interno",
	doesNotApply: "No aplica",
	pendingToPay: "Pendiente por pagar",
	pendingToCharge: "Pendiente por cobrar",
	permissionToCharge: "Permiso para cobrar",
	reports: "Reportes",
	export: "Exportar",
	filter: "Filtrar",
	reason: "Motivo",
	cancelShopping: "Cancelar compra",
	cancellationReason: "Motivo de cancelación",
	cancelled: "Cancelada",
	denyPayment: "Denegar pago",
	customersWithBills: "Clientes con facturas",
	showInDirectory: "Mostrar en el directorio",
	token: "Token",
	manual: "Manual",
	home: "Inicio",
	available: "Disponible",
	notAvailable: "No disponible",
	availability: "Disponibilidad",
	responsibleName: "Nombre del responsable",
	order: "Pedido",
	route: "Ruta",
	routes: "Rutas",
	addRoute: "Añadir ruta",
	editRoute: "Editar ruta",
	from: "Desde",
	to: "Hasta",
	percentage: "Porcentaje",
	originCountry: "País origen",
	originState: "Estado origen",
	originCity: "Ciudad origen",
	destinationCountry: "País destino",
	destinationState: "Estado destino",
	destinationCity: "Ciudad destino",
	verifiedShippings: "Envios verificados",
	notVerifiedShippings: "Envios no verificados",
	currency: "Moneda",
	accountNumberEmailPhone: "Nro. de cuenta / E-mail / Tlf",
	telegramConnection: "Conexión con Telegram",
	ratePerKm: "Tarifa por km",
	minimumRate: "Tarifa minima",
	enableGeolocationCharge: "Activar cobro por geolocalización",
	disableGeolocationCharge: "Desactivar cobro por geolocalización",
	observation: "Observación",
	dashboardEvents: "Eventos",
	ticketFaqs: "Preguntas frecuentes",
	clients: "Clientes",
	bills: "Facturas",
	bots: "Bots",
	bot: "Bot",
	accounts: "Cuentas",
	active: "Activo",
	inactive: "Inactivo",
	nextPayment: "Siguiente Pago",
	addEvent: "Añadir evento",
	fee: "Tarifa",
	errorFee: "Por favor, especifique la tarifa",
	webUrl: "Dirección web",
	telegramBotUser: "Usuario - telegram bot",
	telegramBotToken: "Telegram bot token",
	telegramBotUserError: "Por favor, especifique el usuario - telegram bot",
	telegramBotTokenError: "Por favor, especifique el telegram bot token",
	someWentWrong: "Ha ocurrido un error inesperado.",
	section: "Sección",
	sectionError: "Por favor, especifique la sección",
	eventIdError: "Por favor, especifique el id del evento",
	eventIt: "Id del evento",
	webUrlError: "Por favor, especifique la dirección web",
	confirmContinue: "Click para continuar",
	editAccount: "Editar Cuenta",
	aproved: "Aprobada",
	specialAcount: "Cuenta especial",
	ticket_quantity: "Cantidad de tickets",
	text: "Descripción de compra",
};
